import { AUTH_MODE } from "components/Common/constants";
import React, { useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
} from "reactstrap";

import CustomLogo from "assets/img/cust-transparent-icon-1024.png";
import { PAYMENT_TERMS_STATUS } from "components/Common/constants";
import { REGEX } from "components/Common/constants";
import { sendOtpCustomer } from "actions/public";

const TOTAL_STEPS = 3;

function StepEmail({
  formData,
  updateField,
  loading,
  nextStep,
  setLoading,
  setAuthMode,
  notify,
}) {
  const [error, setError] = useState("");

  const sendOTP = async () => {
    setError("");

    if (!formData.email.value.trim()) {
      setError("Please enter your email address.");
      return;
    }

    if (!REGEX.EMAIL_REGEX.test(formData.email.value)) {
      setError("Please enter a valid email.");
      return;
    }

    try {
      setLoading(true);
      await new Promise((resolve) =>
        setTimeout(resolve, 1500)
      );

      nextStep();
    } finally {
      setLoading(false);
    }
  };

  const validateEmail = (value) => {
    if (!value) return "Please enter email.";
    if (!REGEX.EMAIL_REGEX.test(value)) return "Please enter a valid email.";
    return "";
  };

  const handleSendOtp = async () => {
    const error = validateEmail(formData.email.value);
    if (error) {
      setError(error);
      return;
    }

    setLoading(true);
    try {
      const response = await sendOtpCustomer({ email: formData.email.value });
      if (response?.code === 200) {
        notify("success", response?.message || "OTP sent successfully");
        // setStep({ screen: "otp", uuid: response?.data || "" });
        nextStep();
        // startTimer(); // Start the 60-second timer
      } else {
        const message = Array.isArray(response?.message)
          ? response?.message[0]?.Msg
          : response?.message || "OTP verification failed";
        notify("danger", message);
      }
    } catch (e) {
      const message = Array.isArray(e?.message)
        ? e?.message[0]?.Msg
        : e?.message || "OTP verification failed";
      notify("danger", message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form>

      {/* <div className="wizard-icon">
          <i className="fa fa-envelope-open-text"></i>
        </div> */}

      {/* <h3 className="wizard-title">
          Verify your Email
        </h3> */}

      <FormGroup className={`modern-form-group ${error ? "has-danger" : ""}`}>
        {/* <Label>Email Address</Label> */}

        <div className="modern-input">
          <i className="fa fa-envelope input-icon"></i>
          <Input
            type="email"
            placeholder="Enter your email"
            value={formData.email.value}
            onChange={(e) =>
              updateField("email", e.target.value)
            }
          />
        </div>

        {error && (
          <div className="field-error">
            {error}
          </div>
        )}

      </FormGroup>

      <Button
        color="default"
        block
        size="lg"
        className="login-btn mt-5"
        onClick={handleSendOtp}
        disabled={loading}
      >
        {loading ?
          <i className="fa fa-spinner fa-spin mr-2" />
          :
          "Send OTP"}
      </Button>

      <div className="already-account">
        Already have an account?
        <span
          onClick={() => {
            setAuthMode(AUTH_MODE.LOGIN)
          }}
        >
          Sign In
        </span>
      </div>

    </Form>
  );
};

function StepOTP({
  otp,
  setOtp,
  formData,
  updateField,
  loading,
  nextStep,
  prevStep,
  setAuthMode,
}) {
  const inputs = React.useRef([]);
  const [timer, setTimer] = useState(60);
  const [otpExpired, setOtpExpired] = useState(false);

  React.useEffect(() => {
    const firstEmptyIndex = otp.findIndex((digit) => digit === "");
    if (firstEmptyIndex !== -1) {
      inputs.current[firstEmptyIndex]?.focus();
    }
  }, [otp]);

  React.useEffect(() => {
    if (timer <= 0) {
      setOtpExpired(true);
      return;
    }

    const interval = setInterval(() => {
      setTimer((t) => t - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  // React.useEffect(() => {
  //   const value = otp.join("");
  //   updateField("otp", value);
  //   if (value.length === 6) {
  //     verifyOTP(value);
  //   }
  // }, [otp]);

  const verifyOTP = async (value) => {
    await new Promise((r) => setTimeout(r, 1200));
    nextStep();
  };

  const changeOTP = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const copy = [...otp];
    copy[index] = value.slice(-1);

    setOtp(copy);

    if (value && index < 5) {
      inputs.current[index + 1]?.focus();
    }

    const otpValue = copy.join("");

    updateField("otp", otpValue);

    // if (otpValue.length === 6) {
    //   verifyOTP(otpValue);
    // }
  };

  const keyDown = (e, index) => {
    if (
      e.key === "Backspace" &&
      !otp[index] &&
      index > 0
    ) {
      inputs.current[index - 1].focus();
    }
  };

  const pasteOTP = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .trim()
      .slice(0, 6);
    if (!/^\d+$/.test(pasted)) return;
    const arr = pasted.split("");
    while (arr.length < 6) arr.push("");
    setOtp(arr);
    inputs.current[5].focus();
  };

  return (
    <>
      {/* <div className="wizard-icon">
          <i className="fa fa-shield-check"></i>
        </div> */}

      <div className="text-center login-header">
        <h2 className="mb-0 pb-0 text-deep-blue">Verify OTP</h2>
        <p className="text-center mt-3 mb-0">
          Enter the OTP sent to
        </p>
        <strong>{formData.email.value}</strong>
      </div>


      <div className="otp-container mt-3">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputs.current[index] = el)}
            value={digit}
            maxLength={1}
            onPaste={pasteOTP}
            onKeyDown={(e) => keyDown(e, index)}
            onChange={(e) =>
              changeOTP(index, e.target.value)
            }
          />
        ))}
      </div>
      {otpExpired && (
        <div className="field-error mt-3 text-center">
          OTP has expired. Please resend the OTP to continue.
        </div>
      )}

      <div className="otp-footer mt-5">
        <span className="change-email" onClick={prevStep}>
          Change Email
        </span>

        {timer > 0 ? (
          <span>
            Resend OTP in
            <strong> {timer}s</strong>
          </span>
        ) : (
          <Button
            color="link"
            onClick={() => {
              setTimer(60);
              setOtpExpired(false);
              setOtp(["", "", "", "", "", ""]);
              inputs.current[0]?.focus();
            }}
          >
            Resend OTP
          </Button>
        )}
      </div>

      <div className="d-flex mt-4">
        <Button
          color="default"
          block
          className="login-btn mt-4"
          size="lg"
          disabled={loading || otpExpired}
          onClick={() => (otp.length === 6) &&
            verifyOTP(otp)}
        >
          {loading ?
            <i className="fa fa-spinner fa-spin mr-2" />
            : "Verify OTP"}
        </Button>
      </div>

      <div className="already-account">
        Already have an account?
        <span
          onClick={() => {
            setAuthMode(AUTH_MODE.LOGIN)
          }}
        >
          Sign In
        </span>
      </div>
    </>
  );
};

function StepDetails({
  formData,
  updateField,
  loading,
  prevStep,
  setAuthMode,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const createAccount = async () => {
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.address ||
      !formData.password
    ) {
      alert("Please complete all required fields.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match.");
      return;
    }
    alert("Registration Successful!");
  };

  return (
    <>
      {/* <div className="wizard-icon">
          <i className="fa fa-user-plus"></i>
        </div> */}
      <div className="mb-4 mt-4 text-center">
        <h2 className="wizard-title text-deep-blue">
          Complete Your Profile
        </h2>
        <strong>{formData.email.value}</strong>
      </div>

      <p className="mb-2">Select account type:</p>
      <div className="account-type-selector mb-4">
        <div
          className={`account-type-card ${formData.accountType.value === "INDIVIDUAL" ? "active" : ""
            }`}
          onClick={() => updateField("accountType", "INDIVIDUAL")}
        >
          {/* <i className="fa fa-user-circle"></i> */}

          <div>
            <h6>Personal Account</h6>
            <small>Individual</small>
          </div>
        </div>

        <div
          className={`account-type-card ${formData.accountType.value === "ORGANIZATION" ? "active" : ""
            }`}
          onClick={() => updateField("accountType", "ORGANIZATION")}
        >
          {/* <i className="fa fa-building"></i> */}

          <div>
            <h6>Business Account</h6>
            <small>Organization</small>
          </div>
        </div>
      </div>
      <hr />

      <FormGroup className={`modern-form-group ${formData.firstName.error ? "has-danger" : ""}`}>
        {/* <Label>First Name</Label> */}

        <div className="modern-input">
          <i className="fa fa-user input-icon"></i>

          <Input
            placeholder="Enter your first name"
            value={formData.firstName.value}
            onChange={(e) =>
              updateField("firstName", e.target.value)
            }
          />
        </div>
        {formData.firstName.error && (
          <small className="validation-error">
            {formData.firstName.error}
          </small>
        )}
      </FormGroup>

      <FormGroup className="modern-form-group">
        {/* <Label>Last Name</Label> */}

        <div className="modern-input">
          <i className="fa fa-user input-icon"></i>

          <Input
            placeholder="Enter your last name"
            value={formData.lastName.value}
            onChange={(e) =>
              updateField("lastName", e.target.value)
            }
          />
        </div>
      </FormGroup>

      <FormGroup className="modern-form-group">
        {/* <Label>Contact Number</Label> */}

        <div className="modern-input">
          <i className="fa fa-phone input-icon"></i>

          <Input
            type="text"
            placeholder="Enter your contact number"
            value={formData.address.value}
            maxLength={9}
            onChange={(e) =>
              updateField("address", e.target.value)
            }
          />
        </div>
      </FormGroup>

      <FormGroup className="modern-form-group">
        {/* <Label>Address</Label> */}

        <div className="modern-input">
          <i className="fa fa-map-marker-alt input-icon"></i>

          <Input
            type="text"
            placeholder="Enter your address"
            value={formData.address.value}
            onChange={(e) =>
              updateField("address", e.target.value)
            }
          />
        </div>
      </FormGroup>

      <FormGroup className="modern-form-group">
        <div className="modern-input">
          <i className="fa fa-credit-card input-icon"></i>

          <Input
            type="select"
            value={formData.paymentTerms.value}
            onChange={(e) =>
              updateField("paymentTerms", e.target.value)
            }
          >
            {Object.values(PAYMENT_TERMS_STATUS).map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </Input>
        </div>
      </FormGroup>

      <FormGroup className="modern-form-group">
        {/* <Label>VAT ID (Optional)</Label> */}

        <div className="modern-input">
          <i className="fa fa-file-invoice input-icon"></i>

          <Input
            placeholder="Enter VAT ID"
            value={formData.vatId.value}
            onChange={(e) =>
              updateField("vatId", e.target.value)
            }
          />
        </div>
      </FormGroup>


      <FormGroup className="modern-form-group">
        {/* <Label>Password</Label> */}

        <div className="modern-input">
          <i className="fa fa-lock input-icon"></i>

          <Input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={formData.password.value}
            onChange={(e) =>
              updateField("password", e.target.value)
            }
          />

          <button
            type="button"
            className="password-toggle"
            onClick={() =>
              setShowPassword(!showPassword)
            }
          >
            <i
              className={`fa ${showPassword
                ? "fa-eye-slash"
                : "fa-eye"
                }`}
            />
          </button>
        </div>
      </FormGroup>

      <FormGroup className="modern-form-group">
        {/* <Label>Confirm Password</Label> */}

        <div className="modern-input">
          <i className="fa fa-lock input-icon"></i>

          <Input
            type={showConfirm ? "text" : "password"}
            placeholder="Confirm Password"
            value={formData.confirmPassword.value}
            onChange={(e) =>
              updateField(
                "confirmPassword",
                e.target.value
              )
            }
          />

          <button
            type="button"
            className="password-toggle"
            onClick={() =>
              setShowConfirm(!showConfirm)
            }
          >
            <i
              className={`fa ${showConfirm
                ? "fa-eye-slash"
                : "fa-eye"
                }`}
            />
          </button>
        </div>
      </FormGroup>

      <div className="privacy-check mt-4 pl-2">
        <label className="privacy-label">
          <input
            type="checkbox"
            checked={formData.acceptPrivacy.value}
            onChange={(e) =>
              updateField("acceptPrivacy", e.target.checked)
            }
          />

          <span>
            I agree to the{" "}
            <a
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </span>
        </label>
      </div>

      <div className="d-flex mt-3">
        {/* <Button
            outline
            color="secondary"
            onClick={prevStep}
          >
            <i className="fa fa-arrow-left mr-2" />
            Back
          </Button> */}

        <Button
          color="default"
          block
          className="login-btn mt-4"
          size="lg"
          disabled={loading || !formData.acceptPrivacy}
          onClick={createAccount}
        >
          {loading ?
            <i className="fa fa-spinner fa-spin mr-2" />
            : "Create Account"}
        </Button>
      </div>

      <div className="already-account">
        Already have an account?
        <span
          onClick={() => {
            setAuthMode(AUTH_MODE.LOGIN)
          }}
        >
          Sign In
        </span>

      </div>
    </>
  );
};

function SignUp({ setAuthMode }) {
  const notificationAlertRef = useRef(null);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const [formData, setFormData] = useState({
    email: { value: "", error: "" },
    otp: { value: "", error: "" },
    firstName: { value: "", error: "" },
    lastName: { value: "", error: "" },
    address: { value: "", error: "" },
    paymentTerms: { value: "", error: "" },
    vatId: { value: "", error: "" },
    password: { value: "", error: "" },
    confirmPassword: { value: "", error: "" },
    acceptPrivacy: { value: false, error: "" },
    accountType: { value: "INDIVIDUAL", error: "" },
  });

  const notify = (type, message) => {
    const options = {
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const updateField = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value,
        error: "",
      },
    }));
  };

  const nextStep = () => {
    if (step < TOTAL_STEPS) setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  return (
    <Card className="register-card">
      <CardBody className="p-0">

        <div className="logo-container">
          <img
            src={CustomLogo}
            alt=""
            className="cust-logo"
          />
          <span className="cust-head">Falcon Customer</span>
        </div>

        {step === 1 &&
          <div className="text-center login-header">
            <h2 className="mb-0 pb-0 mt-4 text-deep-blue">Create Account</h2>
            <p className="text-center mt-3 mb-0">
              Create an account to get started.
            </p>

          </div>}

        {/* Progress */}

        {/* <div className="stepper">
          <div className="step-line">
            <div
              className="step-line-fill"
              style={{
                width: `${progress}%`
              }}
            />
          </div>
          {[1, 2, 3].map((item) => (
            <div
              key={item}
              className={`step-circle ${step >= item ? "active" : ""
                }`}
            >
              {step > item ? (
                <i className="fa fa-check" />
              ) : (
                item
              )}
            </div>
          ))}

        </div> */}

        {/* <div className="step-labels">
          <span>Email</span>
          <span>Verify</span>
          <span>Details</span>
        </div> */}

        <div className="wizard-body">

          {step === 1 && (
            <StepEmail
              formData={formData}
              updateField={updateField}
              loading={loading}
              nextStep={nextStep}
              setLoading={setLoading}
              setAuthMode={setAuthMode}
              notify={notify}
            />
          )}

          {step === 2 && (
            <StepOTP
              otp={otp}
              setOtp={setOtp}
              formData={formData}
              updateField={updateField}
              loading={loading}
              nextStep={nextStep}
              prevStep={prevStep}
              setAuthMode={setAuthMode}
              notify={notify}
            />
          )}

          {step === 3 && (
            <StepDetails
              formData={formData}
              updateField={updateField}
              loading={loading}
              prevStep={prevStep}
              setAuthMode={setAuthMode}
              notify={notify}
            />
          )}

        </div>

      </CardBody>

    </Card>
  );
}

export default React.memo(SignUp);